import { AxiosResponse } from "axios";
import * as stream from "stream";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectCurrentUser,IpaUserExtended} from "../../../shared/sagas/auth/authSlice";
import { getDisbursementHistoryDetails, setDisbursementHistoryDetails, setDisbursementHistoryDetailError, setDisbursementHistoryDetailsExport } from "./pmDisbursementsSlice";
import { Configuration, PmsApi, PmDisbursementsDTO, DisbursementSearchParamsDTO } from "@inosio/payments-sdk";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

enum reportExportType {
  PDF = "PDF",
  CSV = "CSV",
}

export function requestGetDisbursementHistory(access_token: string, pmUUID: string, trxdto: DisbursementSearchParamsDTO, exportAs?: reportExportType, fileName?: string) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);
  const responseType = exportAs === undefined ? "json" : "blob";
  const contentDisposition = exportAs === undefined ? "" : exportAs === "CSV" ? "text/csv" : "application/pdf";
  const headerParams = {
    "Content-Disposition": contentDisposition,
  };

  return ipaPmAPI.searchDisbursementsByPM(pmUUID, trxdto, exportAs, fileName, { responseType, headers: headerParams });
}

export function* handleGetDisbursementHistory(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    let response: AxiosResponse<PmDisbursementsDTO | stream> = yield call(requestGetDisbursementHistory, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload, action.payload.exportAs, action.payload.fileName);

    if (response.headers["content-type"].startsWith("application/json")) {
      const { data } = response;
      yield put(setDisbursementHistoryDetails(data));
    } else {
      const fileType = action.payload.exportAs === "PDF" ? "application/pdf" : "text/csv";
      const fileExtension = action.payload.exportAs === "PDF" ? "pdf" : "csv";

      const url = window.URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: fileType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${action.payload.fileName}.${fileExtension}`); //or any other extension
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
    }
    yield put(setDisbursementHistoryDetailsExport())
  } catch (error: any) {
    yield put(setDisbursementHistoryDetailError({
      message: error?.response?.data?.message,
      statusCode: error?.response?.data?.statusCode
    }));
  }
}

export function* pmDisbursementsSaga() {
  yield takeLatest(getDisbursementHistoryDetails.type, handleGetDisbursementHistory);
}
